export { SurfaceTextCard } from './SurfaceTextCard';
export type { SurfaceTextCardProps } from './SurfaceTextCard';
